module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/14.a287d6a9.png";